import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconDocumentOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="1em" height="1em"><path d="M78.62 33.3 60.07 14.64a2.13 2.13 0 0 0-1.52-.64H22.91a2.17 2.17 0 0 0-2.16 2.17v67.66A2.17 2.17 0 0 0 22.91 86h54.18a2.17 2.17 0 0 0 2.16-2.17v-49a2.2 2.2 0 0 0-.63-1.53M61 21.41l11.14 11.25H61ZM25.06 81.66V18.34h31.33V37h18.55v44.66Z" /></svg>
);
